module.exports = __webpack_public_path__ + "img/01.bc71ccbd.png";